import { useEffect, useRef } from "react";
import Peer from "simple-peer";
import socket from "../socket"; // ✅ Use shared socket

export const useAudioCall = (myId, remoteUserId) => {
  const peerRef = useRef(null);
  const streamRef = useRef(null);

  const startCall = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    streamRef.current = stream;

    const peer = new Peer({ initiator: true, trickle: false, stream });

    peer.on("signal", (signal) => {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      socket.emit("call-user", {
        to: remoteUserId,
        from: myId,
        signal,
        callerInfo: {
          id: userInfo._id,
          name: userInfo.name,
          email: userInfo.email,
          avatar: userInfo.pic,
        },
      });
    });

    peer.on("stream", (remoteStream) => {
      const audio = new Audio();
      audio.srcObject = remoteStream;
      audio.play();
    });

    socket.on("call-answered", ({ signal }) => {
      peer.signal(signal);
    });

    socket.on("call-accepted", ({ signal }) => {
      peer.signal(signal);
    });

    peerRef.current = peer;
  };

  const answerCall = async (signal) => {
    if (!signal) {
      console.warn("answerCall called with undefined signal");
      return;
    }

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    streamRef.current = stream;

    const peer = new Peer({ initiator: false, trickle: false, stream });

    peer.on("signal", (answerSignal) => {
      socket.emit("answer-call", {
        to: remoteUserId,
        signal: answerSignal,
      });
    });

    peer.on("stream", (remoteStream) => {
      const audio = new Audio();
      audio.srcObject = remoteStream;
      audio.play();
    });

    peer.signal(signal);
    peerRef.current = peer;
  };

  useEffect(() => {
    if (!myId) return;
    socket.emit("join", myId);

    // Optional logging
    socket.on("call:incoming", ({ from }) => {
      console.log("Incoming call from", from);
    });

    return () => {
      socket.off("call:incoming");
    };
  }, [myId]);

  return { startCall, answerCall };
};
